<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0px;">Many thanks to people who made this book possible:</p><br/>
<p style="text-indent:0px;">Caren Niele for setting me off on this journey when the English language was a mystery to me.</p><br/>
<p style="text-indent:0px;">To Olga Botcharova and Laura Zam for advice and encouragement.</p><br/>
<p style="text-indent:0px;">To Inkwell and West Boynton writers' groups.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0ea55e08